import BonesAndJoints from "../assets/focusareas-green/bones-and-joint.svg";
import Energy from "../assets/focusareas-green/energy.svg";
import Focus from "../assets/focusareas-green/focus.svg";
import SportsPerformance from "../assets/focusareas-green/sports-performance.svg";
import Mood from "../assets/focusareas-green/mood.svg";
import Sleep from "../assets/focusareas-green/sleep.svg";
import Stress from "../assets/focusareas-green/stress.svg";
import Digestion from "../assets/focusareas-green/digestion.svg";
import ImmuneSystem from "../assets/focusareas-green/immune-system.svg";
import Skin from "../assets/focusareas-green/skin.svg";
import Nails from "../assets/focusareas-green/nail.svg";
import Heart from "../assets/focusareas-green/heart.svg";
import Eyes from "../assets/focusareas-green/eyes.svg";
import Hair from "../assets/focusareas-green/hair.svg";
import MusclePain from "../assets/focusareas-green/muscle-pain.svg";

export const FOCUS_AREAS = [
  {
    name: ["Energy", "Energie"],
    img: Energy,
  },
  {
    name: ["Focus", "Schwerpunkt"],
    img: Focus,
  },
  {
    name: ["Sport Performance", "Sportliche Leistung"],
    img: SportsPerformance,
  },
  {
    name: ["Mood", "Stimmung"],
    img: Mood,
  },
  {
    name: ["Sleep", "Schlaf"],
    img: Sleep,
  },
  {
    name: ["Stress", "Stress"],
    img: Stress,
  },
  {
    name: ["Digestion", "Verdauung"],
    img: Digestion,
  },
  {
    name: ["Immune System", "Immunsystem"],
    img: ImmuneSystem,
  },
  {
    name: ["Skin", "Haut"],
    img: Skin,
  },
  {
    name: ["Nails", "Nägel"],
    img: Nails,
  },
  {
    name: ["Heart", "Herz"],
    img: Heart,
  },
  {
    name: ["Eyes", "Augen"],
    img: Eyes,
  },
  {
    name: ["Muscle Pain", "Muskelschmerzen"],
    img: MusclePain,
  },
  {
    name: ["Bones and Joints", "Knochen und Gelenke"],
    img: BonesAndJoints,
  },
  {
    name: ["Hair", "Haare"],
    img: Hair,
  },
];
